// IE兼容性 垫片
// import VueI18n from "vue-i18n";
// import enUS from "./core/lang/en";
// import zhCN from "./core/lang/zh";
// import { getCookie } from "./core/utils/util.js";
import "@/core/less/globalStyle.less";
/*业务组件 start*/

import AdvSearch from "./core/work-components/adv-search";
import DataForm from "./core/work-components/data-form";
import DataImport from "./core/work-components/data-import";
import EmapUploadfile from "./core/work-components/emap-uploadfile";
import ResListView from "./core/work-components/list-view";
import SearchPanel from "./core/work-components/search-panel"; // import WeEditor from "./core/work-components/we-editor";

import WeSelectPerson from "./core/work-components/we-select-person/index";
import WeSortPanel from "./core/work-components/we-sort-panel";
import WeekTable from "./core/work-components/week-table";
import WeDataTable from "./core/work-components/we-data-table"; // import AdvDataImport from "./core/work-components/adv-data-import";

/*业务组件 end*/

/*基础组件 start*/

import ResInput from "./core/base-components/res-input";
import ResLabel from "./core/base-components/res-label";
import ResRadio from "./core/base-components/res-radio";
import ResCheckbox from "./core/base-components/res-checkbox";
import ResInputnumber from "./core/base-components/res-inputnumber";
import ResTextarea from "./core/base-components/res-textarea";
import ResDatepicker from "./core/base-components/res-date-picker";
import ResDaterangepicker from "./core/base-components/res-date-range-picker";
import ResSelect from "./core/base-components/res-select";
import ResRate from "./core/base-components/res-rate";
import ResColorPicker from "./core/base-components/res-color-picker";
import ResSlider from "./core/base-components/res-slider";
import ResSwitch from "./core/base-components/res-switch";
import ResText from "./core/base-components/res-text";
import ResLink from "./core/base-components/res-link";
import ResSteps from "./core/base-components/res-steps";
import ResButton from "./core/base-components/res-button";
import ResCascader from "./core/base-components/res-cascader";
import ResProgress from "./core/base-components/res-progress";
import ResDropdown from "./core/base-components/res-dropdown";
import resDivider from "./core/base-components/res-divider";
/*基础组件 end*/

/*报表组件 start*/

import ResCharts from "./core/chart-components/res-chart";
import ResChartBar from "./core/chart-components/res-chart-bar";
import ResChartLine from "./core/chart-components/res-chart-line";
import ResChartPie from "./core/chart-components/res-chart-pie";
/*报表组件 end*/
// 多语言处理
// const loadLang = function (Vue, lang, locale, i18n) {
//   if (locale) {
//     locale("en", { ...locale("en"), ...enUS });
//     locale("zh", { ...locale("zh"), ...zhCN });
//     Vue.config.lang = lang;
//   } else if (i18n) {
//     i18n.setLocaleMessage("en", { ...i18n.messages["en"], ...enUS });
//     i18n.setLocaleMessage("zh", { ...i18n.messages["zh"], ...zhCN });
//     i18n.locale = lang;
//   } else {
//     Vue.use(VueI18n);
//     Vue.config.lang = lang;
//   }
// };

const version = "0.1.0";
const description = "res2 components for  pc";
const author = "金智教育 wisedu";
const components = [AdvSearch, DataForm, DataImport, EmapUploadfile, ResListView, SearchPanel, // WeEditor,
WeSelectPerson, WeSortPanel, WeekTable, WeDataTable, // AdvDataImport,
ResInput, ResLabel, ResRadio, ResCheckbox, ResInputnumber, ResTextarea, ResDatepicker, ResDaterangepicker, ResSelect, ResRate, ResColorPicker, ResSlider, ResSwitch, ResText, ResLink, ResSteps, ResButton, ResCascader, ResProgress, ResDropdown, ResCharts, ResChartBar, ResChartLine, ResChartPie, resDivider]; // const localeLang = getCookie("EMAP_LANG") || "zh";

const install = function (Vue // opts = {
//   lang: localeLang,
//   locale: null,
//   i18n: null,
//   components: [],
// }
) {
  // opts = {
  //   lang: localeLang,
  //   locale: null,
  //   i18n: null,
  //   components: [],
  //   ...opts,
  // };
  // loadLang(Vue, opts.lang, opts.locale, opts.i18n);
  if (install.installed) return;
  window.Work_CMP = {};
  components.forEach(component => {
    Vue.component(component.name, component); //挂载组件

    window.Work_CMP[component.name] = component;
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  AdvSearch,
  DataForm,
  DataImport,
  EmapUploadfile,
  ResListView,
  SearchPanel,
  // WeEditor,
  WeSelectPerson,
  WeSortPanel,
  WeekTable,
  WeDataTable,
  // AdvDataImport,
  ResInput,
  ResLabel,
  ResRadio,
  ResCheckbox,
  ResInputnumber,
  ResTextarea,
  ResDatepicker,
  ResDaterangepicker,
  ResSelect,
  ResRate,
  ResColorPicker,
  ResSlider,
  ResSwitch,
  ResText,
  ResLink,
  ResSteps,
  ResButton,
  ResCascader,
  ResProgress,
  ResDropdown,
  ResCharts,
  ResChartBar,
  ResChartLine,
  ResChartPie,
  resDivider
};